/**
 * @fileoverview feature flag management
 *
 * To enable a feature, run `<feat>.enable()` in your browser console, example:
 * ```
 * FEAT_USER_MANAGEMENT.enable()
 * ```
 *
 * To enable a feature, run `<feat>.disable()` in your browser console, example:
 * ```
 * FEAT_USER_MANAGEMENT.disable()
 * ```
 */
export class Feature {
    key;
    static prefix = `portaal`;
    static makeKey = (key) => [Feature.prefix, key].join('/');
    static enable = (key) => {
        localStorage.setItem(Feature.makeKey(key), 'true');
        window.location.reload();
    };
    static disable = (key) => {
        localStorage.removeItem(Feature.makeKey(key));
        window.location.reload();
    };
    static isEnabled = (key) => Boolean(localStorage.getItem(Feature.makeKey(key)));
    constructor(key) {
        this.key = key;
        window[key] = this;
        if (this.isDisabled) {
            // eslint-disable-next-line no-console
            console.log(`***
                \nAvailable Feature: ${key}.
                \nRun ${key}.enable() in the console to enable it.
                \n***`);
        }
        else {
            // eslint-disable-next-line no-console
            console.log(`***
                \nEnabled Feature: ${key}.
                \nRun ${key}.disable() in the console to disable it.
                \n***`);
        }
    }
    get isEnabled() {
        return Feature.isEnabled(this.key);
    }
    get isDisabled() {
        return !this.isEnabled;
    }
    enable(key = this.key) {
        return Feature.enable(key);
    }
    disable(key = this.key) {
        return Feature.disable(key);
    }
}
// Declare features here
// Example:
// -----------------------------------------------------------------------------
// this file:
// ```
// export const FEAT_USER_MANAGEMENT = new Feature(`FEAT_USER_MANAGEMENT`);
// ```
// another file:
// ```
// import { FEAT_USER_MANAGEMENT } from "../config/feature";
// FEAT_USER_MANAGEMENT.isEnabled()
// ```
export const FEAT_USERS_TABLE_FILTERS = new Feature(`FEAT_USERS_TABLE_FILTERS`);
export const FEAT_USERS_TABLE_PAGINATION = new Feature(`FEAT_USERS_TABLE_PAGINATION`);
export const FEAT_COMMUNICATION_RESET_BUTTON = new Feature(`FEAT_COMMUNICATION_RESET_BUTTON`);
